import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Select } from '@ipc/ipc-components';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import locale from 'date-fns/locale/en-US';
import OperatorImpcSelectionContainer
  from '../../../../common/selection-criteria/operator-impc/container/OperatorImpcSelectionContainer';
import { getLeftCheckedMailProcessingCenters, getRightCheckedMailProcessingCenters } from '../../../../common/user/redux/selectors/UserDataSelectors';
import { onLeftMailProcessingCenterChecked, onRightMailProcessingCenterChecked } from '../../../../common/selection-criteria/operator-impc/redux/actions/OperatorImpcActions';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class ViewTransactionsPageSelectionCriteriaContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      validDate: true,
    };
  }

  onInvalidDate = (message) => {
    this.setState({
      validDate: message === '',
    });
  }

  isApplyEnabled = () => {
    let valid;
    if (this.props.transactionStatus.label === 'All') {
      valid = ((this.props.leftCheckedMailProcessingCenters.length > 0 && this.props.rightCheckedMailProcessingCenters.length > 0)
        && this.state.validDate && this.props.transactionStatus.value !== 'Select...'
      && (moment(this.props.selectedEndDate).diff(moment(this.props.selectedStartDate), 'days') <= 31));
    } else {
      valid = ((this.props.leftCheckedMailProcessingCenters.length > 0 && this.props.rightCheckedMailProcessingCenters.length > 0)
        && this.state.validDate && this.props.transactionStatus.value !== 'Select...');
    }

    return valid;
  }

  togglePanel = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  apply = () => {
    this.props.onApply();
    this.togglePanel();
  }

  render() {
    return (
      <div>
        <div className="selection-criteria-container">
          <h3 className="title-div">{this.props.title}</h3>
          <div className="operator-selector-wrapper">
            <div className="operators">
              <div className="operators-selection-panel">
                <div className="operator">
                  <div className="expand-div-button">
                    <h6>
                      SELECTION CRITERIA
                    </h6>
                    <div onClick={(e) => this.togglePanel(e)} className="expand-button">
                      <FontAwesomeIcon icon={this.state.open ? 'angle-down' : 'angle-right'} className="expand-icon" />
                    </div>
                  </div>
                  <div className={`checkboxtree-div ${this.state.open}`}>
                    <div>
                      <OperatorImpcSelectionContainer
                        {...this.props}
                      />
                      <div className="left-container">
                        <div style={{ float: 'left', marginTop: '10px' }}>
                          <Select
                            placeholder="Generated from Predes"
                            className="select-box"
                            options={this.props.searchOptions}
                            onChange={this.props.onTransactionTypeChange}
                          />
                          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                            <Grid container>
                              <KeyboardDatePicker
                                disableToolbar
                                autoOk
                                format="dd-MM-yyyy"
                                margin="normal"
                                id="date-picker-inline"
                                label="Start Date: "
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                value={this.props.selectedStartDate}
                                onChange={this.props.onStartDateChange}
                                onError={this.onInvalidDate}
                                disabled={this.props.areDatesDisabled}
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                        </div>
                        <div style={{ float: 'right', marginTop: '10px' }}>
                          <Select
                            placeholder={this.props.transactionStatus.label}
                            value={this.props.transactionStatus.value}
                            className="select-box"
                            options={this.props.statusOptions}
                            onChange={this.props.onStatusChange}
                          />
                          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                            <Grid container>
                              <KeyboardDatePicker
                                disableToolbar
                                autoOk
                                format="dd-MM-yyyy"
                                margin="normal"
                                id="date-picker-inline"
                                label="End Date: "
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                value={this.props.selectedEndDate}
                                onChange={this.props.onEndDateChange}
                                minDate={this.props.selectedStartDate}
                                onError={this.onInvalidDate}
                                disabled={this.props.areDatesDisabled}
                              />
                            </Grid>
                          </MuiPickersUtilsProvider>
                          <p style={{ color: 'red' }}>
                            {(this.props.transactionStatus.label === 'All' && moment(this.props.selectedEndDate).diff(moment(this.props.selectedStartDate), 'days') > 31)
                              ? 'Period selection can not be more than one month' : ''}
                          </p>
                        </div>
                      </div>
                      <div className="right-container">
                        <Button
                          disabled={!this.isApplyEnabled()}
                          className={`apply-div-${!this.isApplyEnabled()}`}
                          onClick={this.apply}
                        >
                          APPLY
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    leftCheckedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    rightCheckedMailProcessingCenters: getRightCheckedMailProcessingCenters(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  onLeftMailProcessingCenterChecked,
  onRightMailProcessingCenterChecked,
}, dispatch);

ViewTransactionsPageSelectionCriteriaContainer.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  leftCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  rightCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  selectedStartDate: PropTypes.instanceOf(Date),
  onStartDateChange: PropTypes.func,
  selectedEndDate: PropTypes.instanceOf(Date),
  onEndDateChange: PropTypes.func,
  onApply: PropTypes.func,
  searchOptions: PropTypes.arrayOf(PropTypes.object),
  statusOptions: PropTypes.arrayOf(PropTypes.object),
  onTransactionTypeChange: PropTypes.func,
  onStatusChange: PropTypes.func,
  areDatesDisabled: PropTypes.bool,
  transactionStatus: PropTypes.string,
};

ViewTransactionsPageSelectionCriteriaContainer.defaultProps = {
  open: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewTransactionsPageSelectionCriteriaContainer);
